import { createUrlWithSourceQueryParams } from "@crehana/analytics";
import { MAIN_MENU_AMPLITUDE_SOURCE_DETAIL_KEY } from "../constants.js";
const createUrlWithAmplitudeSource = ({ url, amplitudePageName, sourceDetail })=>createUrlWithSourceQueryParams({
        url,
        source: amplitudePageName,
        sourceDetail: sourceDetail || MAIN_MENU_AMPLITUDE_SOURCE_DETAIL_KEY
    });
const utils_createUrlWithAmplitudeSource = createUrlWithAmplitudeSource;
export default utils_createUrlWithAmplitudeSource;
